import { Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { formatCentsAsUsd } from "@src/appV2/lib/Money/utils/currency";

import { Button } from "../../../components/Button";
import { DialogFooter } from "../../../components/DialogFooter";
import { InstantPayIndicator } from "../../../WorkerShifts/components/InstantPayIndicator";

interface ShiftBundleBottomSheetFooterProps {
  totalPayInMinorUnits: number | undefined;
  isInstantPay: boolean;
  isBookable: boolean;
  onSelectShifts: () => void;
}

export function ShiftBundleBottomSheetFooter(props: ShiftBundleBottomSheetFooterProps) {
  const { totalPayInMinorUnits, isInstantPay, isBookable, onSelectShifts } = props;

  return (
    <DialogFooter withShadow orientation="vertical">
      <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
        <Stack spacing={3} sx={{ paddingLeft: 5 }}>
          {isDefined(totalPayInMinorUnits) && (
            <Text semibold variant="h5">
              <Text inline variant="body1" sx={(theme) => ({ color: theme.palette.text.tertiary })}>
                Up to{" "}
              </Text>
              {formatCentsAsUsd(totalPayInMinorUnits)}
            </Text>
          )}
          {isInstantPay && <InstantPayIndicator />}
        </Stack>

        <Button disabled={!isBookable} variant="contained" size="large" onClick={onSelectShifts}>
          {isBookable ? "Select shifts" : "Can't book"}
        </Button>
      </Stack>
    </DialogFooter>
  );
}
